module.exports = __webpack_public_path__ + "static/media/morning.74d23197.png";